import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { projectTimezoneIdSelector } from '../../../reducers/projects';
import { timezonesSelector, getTimezoneOffset } from '../../../reducers/timezones';
import { getProjectTime } from '../../../helpers/timezone';
// import { timeZoneHelperSelector } from '../TimeZone/TimeZoneHelpers';

if (__CLIENT__) {
  require('react-day-picker/lib/style.css');
}

const Selector = createSelector(
  [timezonesSelector, projectTimezoneIdSelector],
  (timezones, projectTimezoneId) =>  ({
    timezoneOffset: getTimezoneOffset(timezones, projectTimezoneId),
  }),
);
// const Selector = createSelector(
//   [timeZoneHelperSelector],
//   (timeZoneHelper) => ({ timeZoneHelper }),
// );
@connect(Selector)
export default class DayPickerInputField extends Component {
  static propTypes = {
    input: PropTypes.object,
    // timeZoneHelper: PropTypes.object,
    dateChange: PropTypes.func,
    timezoneOffset: PropTypes.number,
  }

  handleDayChange = (selectedDay) => {
    const { dateChange, timezoneOffset } = this.props;
    if (!selectedDay) dateChange(null);
    else {
      const date = getProjectTime(timezoneOffset, selectedDay);
      dateChange(date);
    }
  }

  render() {
    const { input: { value }, timezoneOffset } = this.props;
    const formattedDate = value && getProjectTime(timezoneOffset, value).format('MM/DD/YYYY');
    // const formattedDate = value && timeZoneHelper.getProjectTime(value).format('MM/DD/YYYY');
    return (
      <DayPickerInput
        value={formattedDate}
        clickUnselectsDay={true}
        dayPickerProps={{
          containerProps: {
            style: {
              zIndex: 100,
            },
          },
        }}
        onDayChange={this.handleDayChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/TaskStatus/DayPickerInputField.js